import { defineCustomElement } from "vue";
import { Register } from "..";
import F360BannerPadraoCe from "./F360BannerPadrao.ce.vue";

const _register: Register = {
  register() {
    if (!customElements.get("vc-banner-padrao")) {
      const CustomElement = defineCustomElement(F360BannerPadraoCe);
      customElements.define("vc-banner-padrao", CustomElement);
    }
  }
};

export default _register;
